module.exports = __webpack_public_path__ + "images/qrcode-wechat-75ef19f8d3c5a8339965af36c8298b7f.png";